module.exports = __webpack_public_path__ + "img/remove_icon_1.111f7272.webp";